import { fetchAdministracion, fetchMovilizacion } from "./http-common";

const urlListaDataStorage = "ListaDataStorage"

const cargarblobstorage = (listUrlBase) => {
    const data = {
        ListUrlBase: [listUrlBase]
    };
    return fetchMovilizacion.post(`v1/${urlListaDataStorage}/HistoricoAdjuntos`, data);
};

const cargarAdjunto = (data) => {
    return fetchMovilizacion.post(`v1/${urlListaDataStorage}/Adjuntos`, data);
};

const listarAdjuntos = (data: {
    listUrlBase: string[],
    codContenedor: string
}) => {
    return fetchMovilizacion.post(`v1/Blob/ListarAdjuntos`, data);
}

const obtenerBlob = (data: {
    url: string,
    codigo: string
}) => fetchAdministracion.post("BlobStorage/ObtenerBlob", data);

const blobStorageService = {
    cargarblobstorage,
    cargarAdjunto,
    listarAdjuntos,
    obtenerBlob
};

export default blobStorageService;